var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActionPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9206 3.07087C18.1235 2.27337 17.0699 1.83337 15.9429 1.83337C14.816 1.83337 13.7624 2.27337 12.9653 3.07087L2.09903 13.9059C1.92495 14.08 1.83333 14.3092 1.83333 14.5567V19.25C1.83333 19.7542 2.24562 20.1667 2.74954 20.1667H7.44052C7.6879 20.1667 7.91695 20.0659 8.09103 19.9009L18.9298 9.03837C19.7269 8.24087 20.1667 7.18671 20.1667 6.05921C20.1667 4.93171 19.7269 3.87754 18.9298 3.08004L18.9206 3.07087ZM7.05572 18.3334H3.66575V14.9325L12.727 5.89421L16.0987 9.26754L7.05572 18.3334ZM17.6196 7.73671L17.3814 7.97504L14.0097 4.60171L14.248 4.36337C15.1458 3.46504 16.7217 3.46504 17.6196 4.36337C18.0685 4.81254 18.3159 5.40837 18.3159 6.05004C18.3159 6.69171 18.0685 7.28754 17.6196 7.73671Z",
    fill: "#585A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionPencil);
export default __webpack_public_path__ + "static/media/icon_action_pencil.98169c7703ef9bdde917228fc610388d.svg";
export { ForwardRef as ReactComponent };